import React from "react";
import { motion } from "framer-motion";
import { CheckIcon } from "@heroicons/react/24/solid";

interface StepIndicatorProps {
  currentStep: number;
  steps: string[];
}

const StepIndicator: React.FC<StepIndicatorProps> = ({
  currentStep,
  steps,
}) => {
  return (
    <div className="mb-8">
      <div className="flex gap-4 items-center justify-between">
        {steps.map((step, index) => (
          <div key={index} className="flex items-center">
            <div className="flex flex-col gap-2 lg:gap-0 lg:flex-row text-center lg:text-left items-center">
              <motion.div
                initial={false}
                animate={{
                  backgroundColor: index <= currentStep ? "#3B82F6" : "#E5E7EB",
                  scale: index === currentStep ? 1.1 : 1,
                }}
                className="lg:w-10 lg:h-10 w-7 h-7 rounded-full flex items-center justify-center text-white font-semibold"
              >
                {index < currentStep ? (
                  <CheckIcon className="lg:h-6 lg:w-6 h-4 w-4" />
                ) : (
                  <span>{index + 1}</span>
                )}
              </motion.div>
              <span
                className={`lg:ml-3 text-sm font-medium ${
                  index <= currentStep ? "text-blue-600" : "text-gray-500"
                }`}
              >
                {step}
              </span>
            </div>
            {index < steps.length - 1 && (
              <motion.div
                initial={false}
                animate={{
                  backgroundColor: index < currentStep ? "#3B82F6" : "#E5E7EB",
                }}
                className="flex-1 h-1 mx-4 rounded"
              />
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default StepIndicator;
